import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import { createAction } from 'utils';

import Search from 'assets/images/drop_down_filter.svg';

import './LoadMoreSelector.scss';

const LoadMoreSelector = ({
  source,
  onSelectChange = () => {},
  placeholder = '',
  defaultFilter = {},
  loadMoreAction = () => {},
  allType = false,
  labelContainPk = false,
  customItem = () => {},
}) => {
  const dispatch = useDispatch();
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterKey, setFilterKey] = useState('');

  // useEffect(() => {
  //   if (loadMoreAction) {
  //     dispatch(
  //       createAction(loadMoreAction)({
  //         page: currentPage,
  //         search: filterKey,
  //         searchKey: filterKey,
  //         isSelectorLoad: true,
  //         type: allType ? 'AllTypes' : '',
  //         ...defaultFilter,
  //       }),
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (loadMoreAction) {
      dispatch(
        createAction(loadMoreAction)({
          page: 1,
          search: filterKey,
          searchKey: filterKey,
          isSelectorLoad: true,
          type: allType ? 'AllTypes' : '',
          ...defaultFilter,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterKey]);

  const loadMore = () => {
    if (!loadMoreAction) {
      return;
    }
    const nextPage = currentPage + 1;
    console.log('@@55: ', nextPage, filterKey);
    dispatch(
      createAction(loadMoreAction)({
        page: nextPage,
        search: filterKey,
        searchKey: filterKey,
        isSelectorLoad: true,
        type: allType ? 'AllTypes' : '',
        ...defaultFilter,
      }),
    );

    setCurrentPage(nextPage);
  };

  return (
    <div className="load-more-container">
      <div className="filterable-search-bar">
        <Image src={Search} className="filterable-search-bar-icon" />
        <input
          autoFocus
          className="filterable-search-bar-input"
          placeholder={placeholder}
          onChange={(e) => {
            setFilterKey(e.target.value);
          }}
          value={filterKey}
        />
      </div>

      <div
        className="load-more-data-area"
        onScroll={(event) => {
          if (
            event.nativeEvent.target.scrollTop +
              event.nativeEvent.target.clientHeight ===
            event.nativeEvent.target.scrollHeight
          ) {
            // load more action
            loadMore();
            setIsLoadMore(true);
          }
        }}
      >
        {source?.map((item, index) => (
          <div
            key={`load-more-item-${item.pk}`}
            className={'filterable-item'}
            onClick={(e) => onSelectChange(item)}
          >
            {customItem(item)
              ? customItem(item)
              : labelContainPk
              ? `[ID: ${item?.pk}] ${item?.name}`
              : item?.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadMoreSelector;
